import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { EASE } from "./Reveal";
import { WHATSAPP_PRIMARY, WHATSAPP_SECONDARY } from "../siteConfig";

export default function WhatsAppFloat() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const msg = encodeURIComponent(t("whatsapp.msg"));

  return (
    <div className="fixed bottom-6 right-5 md:bottom-8 md:right-8 z-[80]" data-testid="whatsapp-float">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            transition={{ duration: 0.35, ease: EASE }}
            className="absolute bottom-14 right-0 w-[260px] bg-[#0D0E0F] border border-white/10 rounded-[3px] overflow-hidden"
            data-testid="whatsapp-panel"
          >
            <div className="px-4 py-3 border-b border-white/10 eyebrow">{t("whatsapp.title")}</div>
            {[
              { label: t("nx.contact.spainOffice"), num: WHATSAPP_PRIMARY, test: "whatsapp-primary" },
              { label: t("nx.contact.dubaiOffice"), num: WHATSAPP_SECONDARY, test: "whatsapp-secondary" },
            ].map((w) => (
              <a
                key={w.num}
                href={`https://wa.me/${w.num.replace("+", "")}?text=${msg}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={w.test}
                className="flex items-center justify-between px-4 py-3.5 border-b border-white/5 last:border-0 hover:bg-white/[0.04] transition-colors"
              >
                <span className="mono text-[12px] text-[#F3F3F0]">{w.num}</span>
                <span className="eyebrow !text-[9px]">{w.label}</span>
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <button
        data-testid="whatsapp-toggle"
        onClick={() => setOpen(!open)}
        aria-label="WhatsApp"
        className="flex items-center justify-center w-12 h-12 bg-[#111214]/90 backdrop-blur-sm border border-white/10 rounded-[3px] transition-all duration-500 hover:border-white/30"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 3.5a8.5 8.5 0 0 0-7.3 12.8L3.5 20.5l4.3-1.1A8.5 8.5 0 1 0 12 3.5Z"
            stroke="#F3F3F0"
            strokeWidth="1.3"
            strokeLinejoin="round"
          />
          <path
            d="M9.2 8.4c-.3 0-.6.1-.8.4-.3.3-.7.9-.7 1.8 0 1 .7 2.2 1.1 2.8.5.7 1.9 2.3 4.1 3 .8.3 1.4.4 1.9.4.6 0 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1-.1-.1-.3-.2-.6-.3l-1.5-.7c-.2-.1-.4-.1-.6.1l-.6.8c-.1.2-.3.2-.5.1a6.6 6.6 0 0 1-2-1.3 7 7 0 0 1-1.3-1.7c-.1-.2 0-.3.1-.4l.5-.6c.1-.2.2-.3.1-.5L9.9 8.6c-.1-.2-.3-.2-.7-.2Z"
            fill="#25D366"
            fillOpacity="0.85"
          />
        </svg>
      </button>
    </div>
  );
}
